import { getRequest, postRequest } from '@/utils/fetch';

export const getOrderList = (params: any) => {
    return postRequest('/css/v2/order/list', params);
};

// 获取订单详情
// export const getDetailById = (params: any) => {
//     return getRequest('/css/v2/order/detail', params);
// };

// 获取订单详情v3
export const getDetailByIdV3 = (params: any) => {
    return postRequest('/css/v3/order/detail', params);
};
// 获取订单商品列表
export const getGoodsListByOrder = (params) => {
    return getRequest('/css/v2/order/goodsList', params);
};

// 创建工单
export const createWorkOrder = (params: { [key: string]: any }) => {
    return postRequest('/work-order/workOrder/work/create', params);
};

// 编辑工单
export const updateWorkOrder = (params: any) => {
    return postRequest('/work-order/workOrder/work/update', params);
};

// css优惠券相关接口
export const couponSendV2 = (params: any) => {
    return postRequest('/css/coupon/send/v2', params);
};

// CSS查询可以合并的工单
export const aftersaleMergeList = (params: any) => {
    return postRequest('/css/aftersale/merge/list', params);
};

// CSS查询可以合并的物流单
export const aftersaleMergeTrack = (params: any) => {
    return postRequest('/css/aftersale/merge/track', params);
};

// 超规则原因枚举key对应售后类型： 1-换货 2-退 4-修
export const getUpgradeReason = (params: any) => {
    return getRequest('/css/common/upgrade/reason/enum', params);
};
